<template>
  <svg viewBox="0 0 350 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M341.502 50C316.578 50 292.569 -1.07288e-06 267.645 -1.07288e-06H80.4121C55.4886 -1.07288e-06 31.4794 50 6.55594 50C-61.1035 50 419.023 50 341.502 50Z" fill="#F3F5F9"/>
  </svg>
</template>